import React from 'react'
import { TrackingAction } from '../../common/tracking'

type DataTracking = Record<string, unknown>

type DataTrackingProps = {
  dataTrackingAction: TrackingAction,
  dataTrackingProperty: DataTracking,
  children: React.ReactElement
}

export type HTMLTrackingAttributes = {
  'data-tracking-action'?: string,
  'data-tracking-property'?: string
}

export const AddTrackingToChild = ({
  dataTrackingAction,
  dataTrackingProperty,
  children,
}: DataTrackingProps) => {
  if (!React.Children.only(children)) {
    throw new Error('tracking can only be applied to a single child')
  }

  return React.cloneElement(children, {
    'data-tracking-action': dataTrackingAction,
    'data-tracking-property': JSON.stringify(dataTrackingProperty),
  })
}
